import { ErrorWidgetAttr } from "@swiggy-private/core-ui";

import { CART_STATUS_CODES, ERROR_WIDGET_ATTR } from "@dineout-cart-client/constants/Error";
import { IconName } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb/types";

export const getErrorWidgetAttrs = ({
    statusCode,
    ctaIcon,
    ctaText,
    statusMessage,
    titleMessage,
    secondaryCtaText,
    headerIcon,
}: {
    statusCode: number;
    titleMessage?: string;
    statusMessage?: string;
    ctaText?: string;
    ctaIcon?: string;
    secondaryCtaText?: string;
    headerIcon?: IconName;
}): ErrorWidgetAttr => {
    let defaultVal;
    switch (statusCode) {
        case CART_STATUS_CODES.ITEM_OUTOFSTOCK:
            defaultVal = ERROR_WIDGET_ATTR.ITEM_OUTOFSTOCK;
            break;
        case CART_STATUS_CODES.ALL_ITEMS_OOS:
            defaultVal = ERROR_WIDGET_ATTR.ALL_ITEMS_OOS;
            break;
        case CART_STATUS_CODES.MIN_ITEM_BREACH:
            defaultVal = ERROR_WIDGET_ATTR.MIN_ITEM_BREACH;
            break;
        case CART_STATUS_CODES.MAX_INVENTORY_BREACH:
            defaultVal = ERROR_WIDGET_ATTR.MAX_INVENTORY_BREACH;
            break;
        case CART_STATUS_CODES.TABLE_RESERVATION_CHECKED_IN:
            defaultVal = ERROR_WIDGET_ATTR.TABLE_RESERVATION_CHECKED_IN;
            break;
        default:
            defaultVal = ERROR_WIDGET_ATTR.DEFAULT;
            break;
    }

    return {
        cta: ctaText || defaultVal?.cta || "",
        icon: ctaIcon || defaultVal?.icon || "",
        message: statusMessage || defaultVal?.message || "",
        title: titleMessage || defaultVal?.title || "",
        showOverlay: defaultVal?.showOverlay ?? false,
        secondaryCtaText: secondaryCtaText || defaultVal?.secondaryCtaText || "",
        headerIcon: headerIcon || defaultVal?.headerIcon,
    };
};
